function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import TmField from "./components/TmField";
import _ from "lodash";
import TmInput from "./components/TmInput";

class TmSelectInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderOptions", () => {
      const options = _.map(this.props.options, option => {
        const value = _.chain(option).keys().head().value();

        const optionLabel = _.chain(option).values().head().value();

        return /*#__PURE__*/React.createElement("option", {
          key: `${this.props.field}__${value}`,
          value: value
        }, optionLabel);
      });

      return this.props.required ? options : _.concat( /*#__PURE__*/React.createElement("option", {
        key: `${this.props.field}__`,
        value: null
      }, "Choose a ", _.startCase(this.props.field)), options);
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(TmField, this.props, /*#__PURE__*/React.createElement(TmInput, _extends({}, this.props, {
        type: 'select'
      }), this.renderOptions()));
    });
  }

}

export default TmSelectInput;